<div class="min-h-screen bg-gray-50">

  <!-- Loading State -->
  @if (loading()) {
    <div class="min-h-screen flex items-center justify-center">
      <div class="text-center">
        <svg class="animate-spin h-12 w-12 text-blue-600 mx-auto mb-4" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <p class="text-gray-600">Cargando página...</p>
      </div>
    </div>
  }

  <!-- Error State -->
  @if (error() && !loading()) {
    <div class="min-h-screen flex items-center justify-center">
      <div class="text-center max-w-md">
        <svg class="w-20 h-20 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <h1 class="text-2xl font-bold text-gray-800 mb-2">Página no encontrada</h1>
        <p class="text-gray-600 mb-6">Lo sentimos, esta página no existe o no está publicada.</p>
        <a href="/" class="inline-block px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition">
          Volver al inicio
        </a>
      </div>
    </div>
  }

  <!-- Contenido Principal -->
  @if (pageData() && !loading() && !error()) {

    <!-- Hero Section -->
    <section class="relative h-96 bg-gradient-to-r from-slate-900 to-slate-400 overflow-hidden">

      <!-- Imagen de fondo del hero -->
      @if (pageData()!.images.length > 0) {
        <img
          [src]="pageData()!.images[0].url"
          [alt]="pageData()!.images[0].alt_text"
          class="absolute inset-0 w-full h-full object-cover mix-blend-overlay opacity-80">
      }

      <!-- Contenido del hero -->
      <div class="relative h-full flex flex-col justify-center max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="max-w-3xl">
          <h1 class="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-4 drop-shadow-lg leading-tight">
            {{ pageData()!.content_json.hero.title }}
          </h1>

          @if (pageData()!.content_json.hero.subtitle) {
            <p class="text-xl sm:text-2xl text-white/95 drop-shadow-md leading-relaxed">
              {{ pageData()!.content_json.hero.subtitle }}
            </p>
          }
        </div>
      </div>

      <!-- Decoración del hero -->
      <div class="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-gray-50 to-transparent"></div>
    </section>

    <!-- Contenido Principal -->
    <main class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">

      <!-- Secciones de Texto -->
      @for (section of pageData()!.content_json.sections; track $index) {
        @if (section.type === 'text' && section.content) {
          <div class="max-w-none mb-12">
            <div class="bg-white rounded-xl shadow-sm p-8 border border-gray-100">
              <p class="text-gray-700 text-lg leading-relaxed whitespace-pre-line">
                {{ section.content }}
              </p>
            </div>
          </div>
        }
      }

      <!-- HTML Personalizado -->
      @if (hasCustomHtml) {
        <div class="mb-12 custom-html-container" [innerHTML]="sanitizedCustomHtml()"></div>
      }

      <!-- Galería de Imágenes -->
      @if (pageData()!.images.length > 1) {
        <div class="mb-12">
          <h2 class="text-3xl font-bold text-gray-900 mb-6">Galería</h2>

          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            @for (image of pageData()!.images; track image.url) {
              <div class="group relative overflow-hidden rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                <img
                  [src]="image.url"
                  [alt]="image.alt_text"
                  class="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-300">

                <!-- Overlay con alt text -->
                <div class="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                  <p class="text-white text-sm font-medium p-4">
                    {{ image.alt_text }}
                  </p>
                </div>
              </div>
            }
          </div>
        </div>
      }

    </main>

    <!-- Botón CTA Funcional -->
 @if (pageData() && !loading() && !error()) {
  <button
    (click)="goToBooking()"
    class="fixed bottom-6 right-6 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white px-6 py-4 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105 z-50 flex items-center gap-2 font-semibold text-lg"
    aria-label="Hacer una reserva">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
    Reservar Ahora
  </button>
}}

